import { render, staticRenderFns } from "./UserCabinetMenu.vue?vue&type=template&id=56e1daca&scoped=true"
import script from "./UserCabinetMenu.vue?vue&type=script&lang=js"
export * from "./UserCabinetMenu.vue?vue&type=script&lang=js"
import style0 from "./UserCabinetMenu.vue?vue&type=style&index=0&id=56e1daca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e1daca",
  null
  
)

export default component.exports